import { PropsWithChildren } from 'preact/compat';

import styles from '../../FormLayout.module.scss';

export function Item({ children }: PropsWithChildren) {
  return children ? <div className={styles.Item}>{children}</div> : null;
}
